/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import {
  Content,
  TopActions,
  SearchWrapper,
  ActionButtonsGroup,
  PrimaryButton,
  RefreshButton,
  TabContainer,
  TabButton,
  CardList,
  EmptyState,
  ModernCard,
  CardMainInfo,
  AvatarCircle,
  InfoDetails,
  BadgeRole,
  StatusTag,
  CardActions,
  IconButton,
} from './styles'

import UserCreate from '../auth/UserCreate'
import api from '../../services/axios'
import { RiSendPlaneFill } from 'react-icons/ri'
import { FiSearch, FiPlus, FiRefreshCw, FiPhone, FiMail, FiClock, FiEdit2 } from 'react-icons/fi'

import ModalUserEdit from '../../components/Modals/ModalUserEdit'
import ModalDistEdit from '../../components/Modals/ModalDistEdit'
import { Skeleton } from '../../components/Skeletron'
import { useAuth } from '../../context/AuthContext'
import { toast } from 'react-toastify'

interface UsersUpdatedProps {
  id: number
  name: string
  cnpj?: string
  response: string
  gestor_id?: number
  fantasy_name: string
  status?: number
  response_email: string
  response_telefone: string
  cod_dist: string
  visualizador?: number
  conv_familia?: string
}

function UserList() {
  const { user: currentUser } = useAuth()
  const isSuperAdmin = currentUser?.role === 'administrador'

  const [users, setUsers] = useState<any[]>([])
  const [dist, setDist] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [openModal, setOpenModal] = useState(false)
  const [selectedDist, setSelectedDist] = useState<UsersUpdatedProps | null>(null)
  const [openModalDist, setOpenModalDist] = useState(false)
  const [selectedUser, setSelectedUser] = useState<any | null>(null)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [nickname, setNickname] = useState('')
  const [phone, setPhone] = useState('')
  const [status, setStatus] = useState(1)
  const [vincMarca, setVincMarca] = useState('')
  const [vincDist, setVincDist] = useState<number | string>('')
  const [distGestor, setDistGestor] = useState<number | string>('')
  const [distsVisualizador, setDistsVisualizador] = useState<number[]>([])

  // Estados para busca, abas segmentadas e modal de criação
  const [searchQuery, setSearchQuery] = useState('')
  const [activeTab, setActiveTab] = useState<'administradores' | 'suporte' | 'conferentes' | 'gestores' | 'visualizadores' | 'distribuidores'>('suporte')
  const [openCreateModal, setOpenCreateModal] = useState(false)

  useEffect(() => {
    fetchUsers()
    fetchDist()
  }, [])

  const fetchUsers = async () => {
    setLoading(true)
    try {
      const res = await api.get('/users')
      setUsers(res.data)
    } catch (err) {
      console.error('Erro ao buscar usuários:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleEditDistClick = async () => {
    if (!selectedDist) return

    try {
      setLoading(true)
      await api.put(`/dist/updated/${selectedDist.id}`, selectedDist)

      toast.success('Distribuidor atualizado com sucesso!')
      setOpenModalDist(false)
      setSelectedDist(null)
      fetchDist()
    } catch (error) {
      console.error('Erro ao atualizar distribuidor:', error)
      toast.error('Erro ao atualizar distribuidor.')
    } finally {
      setLoading(false)
    }
  }

  const fetchDist = async () => {
    setLoading(true)
    try {
      const res = await api.get('/dist')
      setDist(res.data)
    } catch (err) {
      console.error('Erro ao buscar distribuidores:', err)
    } finally {
      setLoading(false)
    }
  }

  const formatPhone = (value: string) => {
    const digits = value.replace(/\D/g, '')
    const match = digits.match(/^(\d{2})(\d{5})(\d{4})$/)
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`
    }
    return value
  }

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhone(e.target.value)
    setPhone(formatted)
  }

  const handleEditClick = async () => {
    if (!selectedUser) return

    if (!name || !email || !nickname || !phone) {
      toast.warning('Preencha todos os campos obrigatórios.')
      return
    }

    try {
      setLoading(true)
      const payload: any = {
        name,
        email,
        nickname,
        phone,
        status,
      }

      if (password?.trim()) {
        payload.password = password.trim()
      }

      if (selectedUser.role === 'conferente') {
        payload.vinc_marca = vincMarca || null
        payload.vinc_dist = vincDist ? String(vincDist) : null
      }

      if (selectedUser.role === 'gestor') {
        payload.dist_gestor = distGestor ? Number(distGestor) : null
      }

      if (selectedUser.role === 'visualizador') {
        payload.dists_visualizador = distsVisualizador
      }

      await api.put(`/users/${selectedUser.id}`, payload)
      toast.success('Usuário atualizado com sucesso!')
      setOpenModal(false)
      setSelectedUser(null)
      fetchUsers()
    } catch (error) {
      console.error('Erro ao atualizar usuário:', error)
      toast.error('Erro ao atualizar usuário. Tente novamente.')
    } finally {
      setLoading(false)
    }
  }

  const toggleStatus = async (user: any) => {
    try {
      await api.put(`/users/del/${user.id}`)
      fetchUsers()
    } catch (err) {
      console.error('Erro ao atualizar status:', err)
    }
  }

  const toggleStatusActive = async (user: any) => {
    try {
      await api.put(`/users/active/${user.id}`)
      fetchUsers()
    } catch (err) {
      console.error('Erro ao atualizar status:', err)
    }
  }

  const toggleStatusDist = async (distItem: any) => {
    try {
      await api.put(`/dist/del/${distItem.id}`)
      fetchDist()
    } catch (err) {
      console.error('Erro ao atualizar status:', err)
    }
  }

  const toggleStatusActiveDist = async (distItem: any) => {
    try {
      await api.put(`/dist/active/${distItem.id}`)
      fetchDist()
    } catch (err) {
      console.error('Erro ao atualizar status:', err)
    }
  }

  const handleSendEmail = (user: any) => {
    const emailAddr = user.email
    const assunto = encodeURIComponent('Dados de Acesso')

    const corpo = encodeURIComponent(
      `Olá, ${user.name}!\n\n` +
        `Segue credenciais de acesso ao sistema GID:\n` +
        `Login: ${user.nickname}\n` +
        `Senha: ${user.password}\n\n` +
        `Portal: https://gid.grupogsa.com.br\n` +
        `Qualquer dúvida estamos à disposição.`,
    )

    window.location.href = `mailto:${emailAddr}?subject=${assunto}&body=${corpo}`
  }

  const getInitials = (fullName: string) => {
    if (!fullName) return 'U'
    const names = fullName.trim().split(/\s+/)
    if (names.length >= 2) {
      return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase()
    }
    return names[0].substring(0, 2).toUpperCase()
  }

  const sortedUsers = [...users].sort((a, b) => a.name.localeCompare(b.name))
  const sortedDist = [...dist].sort((a, b) => (a.fantasy_name || a.name).localeCompare(b.fantasy_name || b.name))

  const filteredUsers = sortedUsers.filter(
    (user) =>
      user.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.nickname?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.role?.toLowerCase().includes(searchQuery.toLowerCase()),
  )

  const filteredDist = sortedDist.filter(
    (d) =>
      d.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      d.fantasy_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      d.cnpj?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      d.cod_dist?.toLowerCase().includes(searchQuery.toLowerCase()),
  )

  const renderUserList = (list: any[]) => {
    if (list.length === 0) {
      return (
        <EmptyState>
          <FiSearch />
          <p>Nenhum usuário encontrado nesta categoria</p>
        </EmptyState>
      )
    }

    return list.map((user) => {
      const isActive = user.status === 1
      return (
        <ModernCard key={user.id}>
          <CardMainInfo>
            <AvatarCircle $gradientType={user.role}>
              {getInitials(user.name)}
            </AvatarCircle>
            <InfoDetails>
              <div className="name-wrapper">
                <h3>{user.name}</h3>
                <BadgeRole $type={user.role}>{user.role}</BadgeRole>
              </div>
              <div className="meta-wrapper">
                <span className="item" title="Login / Apelido">
                  @{user.nickname}
                </span>
                {user.phone && (
                  <span className="item" title="Telefone">
                    <FiPhone />
                    {user.phone}
                  </span>
                )}
                {user.email && (
                  <span className="item" title="E-mail">
                    <FiMail />
                    {user.email}
                  </span>
                )}
                <span className="item" title="Data da última alteração">
                  <FiClock />
                  {new Date(
                    new Date(user.created_at).getTime() + 3 * 60 * 60 * 1000,
                  ).toLocaleDateString('pt-BR')}
                </span>
              </div>

              {/* Vínculos Visuais do Usuário */}
              <div style={{ marginTop: '8px', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                {user.role === 'gestor' && (
                  user.dist_gestor_nome ? (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', fontSize: '11px', fontWeight: 700, color: '#38bdf8', background: 'rgba(56, 189, 248, 0.12)', border: '1px solid rgba(56, 189, 248, 0.25)', padding: '2px 10px', borderRadius: '999px' }}>
                      🏢 Distribuidor: {user.dist_gestor_nome}
                    </span>
                  ) : (
                    <span style={{ fontSize: '11px', color: '#64748b', fontStyle: 'italic' }}>
                      ⚠ Sem distribuidor vinculado
                    </span>
                  )
                )}

                {user.role === 'visualizador' && (
                  user.dists_visualizador_nomes ? (
                    <span
                      style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', fontSize: '11px', fontWeight: 700, color: '#c084fc', background: 'rgba(192, 132, 252, 0.12)', border: '1px solid rgba(192, 132, 252, 0.25)', padding: '2px 10px', borderRadius: '999px', maxWidth: '400px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                      title={`Distribuidores: ${user.dists_visualizador_nomes}`}
                    >
                      👁️ {user.dists_visualizador_nomes}
                    </span>
                  ) : (
                    <span style={{ fontSize: '11px', color: '#64748b', fontStyle: 'italic' }}>
                      ⚠ Nenhum distribuidor autorizado
                    </span>
                  )
                )}

                {user.role === 'conferente' && (
                  <>
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px',
                        fontSize: '11px',
                        fontWeight: 700,
                        color: '#f472b6',
                        background: 'rgba(244, 114, 182, 0.12)',
                        border: '1px solid rgba(244, 114, 182, 0.25)',
                        padding: '2px 10px',
                        borderRadius: '999px',
                        maxWidth: '350px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                      title={`Marcas: ${user.vinc_marca || 'Todas as Marcas'}`}
                    >
                      🏷️ {user.vinc_marca ? `Marcas: ${user.vinc_marca}` : 'Todas as Marcas'}
                    </span>
                    {user.dist_conferente_nome ? (
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '5px',
                          fontSize: '11px',
                          fontWeight: 700,
                          color: '#38bdf8',
                          background: 'rgba(56, 189, 248, 0.12)',
                          border: '1px solid rgba(56, 189, 248, 0.25)',
                          padding: '2px 10px',
                          borderRadius: '999px',
                          maxWidth: '350px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                        title={`Distribuidores: ${user.dist_conferente_nome}`}
                      >
                        🏢 {user.dist_conferente_nome}
                      </span>
                    ) : (
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '5px',
                          fontSize: '11px',
                          fontWeight: 600,
                          color: '#94a3b8',
                          background: 'rgba(148, 163, 184, 0.12)',
                          border: '1px solid rgba(148, 163, 184, 0.2)',
                          padding: '2px 10px',
                          borderRadius: '999px',
                        }}
                      >
                        🏢 Todos os Distribuidores
                      </span>
                    )}
                  </>
                )}

                {(user.role === 'suporte' || user.role === 'administrador') && (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', fontSize: '11px', fontWeight: 700, color: user.role === 'administrador' ? '#f59e0b' : '#38bdf8', background: user.role === 'administrador' ? 'rgba(245, 158, 11, 0.12)' : 'rgba(56, 189, 248, 0.12)', border: `1px solid ${user.role === 'administrador' ? 'rgba(245, 158, 11, 0.25)' : 'rgba(56, 189, 248, 0.25)'}`, padding: '2px 10px', borderRadius: '999px' }}>
                    🌐 Acesso Global Irrestrito
                  </span>
                )}
              </div>
            </InfoDetails>
          </CardMainInfo>

          <CardActions>
            <StatusTag
              $isActive={isActive}
              onClick={() => (isActive ? toggleStatus(user) : toggleStatusActive(user))}
              title={isActive ? 'Inativar usuário' : 'Ativar usuário'}
            >
              {isActive ? 'Ativo' : 'Inativo'}
            </StatusTag>

            <IconButton
              className="edit"
              onClick={() => {
                setSelectedUser(user)
                setName(user.name)
                setEmail(user.email)
                setPassword('')
                setNickname(user.nickname)
                setPhone(user.phone)
                setStatus(user.status)
                setVincMarca(user.vinc_marca || '')
                setVincDist(user.vinc_dist || '')
                setDistGestor(user.dist_gestor_id || '')
                const visIds = user.dists_visualizador_ids
                  ? String(user.dists_visualizador_ids).split(',').map(Number).filter(Boolean)
                  : []
                setDistsVisualizador(visIds)
                setOpenModal(true)
              }}
              title="Editar"
            >
              <FiEdit2 />
            </IconButton>

            <IconButton
              className="send"
              onClick={() => handleSendEmail(user)}
              title="Enviar credenciais"
            >
              <RiSendPlaneFill />
            </IconButton>
          </CardActions>
        </ModernCard>
      )
    })
  }

  return (
    <Content>
      <TopActions>
        <SearchWrapper>
          <FiSearch />
          <input
            type="text"
            placeholder={
              activeTab === 'distribuidores'
                ? 'Buscar distribuidor por nome, código ou CNPJ...'
                : 'Buscar usuário por nome ou apelido...'
            }
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </SearchWrapper>

        <ActionButtonsGroup>
          <RefreshButton onClick={() => { fetchUsers(); fetchDist(); }} title="Atualizar dados">
            <FiRefreshCw />
          </RefreshButton>
          <PrimaryButton onClick={() => setOpenCreateModal(true)}>
            <FiPlus />
            <span>Novo Cadastro</span>
          </PrimaryButton>
        </ActionButtonsGroup>
      </TopActions>

      <TabContainer>
        <TabButton $active={activeTab === 'suporte'} onClick={() => { setActiveTab('suporte'); setSearchQuery(''); }}>
          Suporte
          <span className="count">{filteredUsers.filter(u => u.role === 'suporte').length}</span>
        </TabButton>
        {isSuperAdmin && (
          <TabButton $active={activeTab === 'administradores'} onClick={() => { setActiveTab('administradores'); setSearchQuery(''); }}>
            Administradores
            <span className="count">{filteredUsers.filter(u => u.role === 'administrador').length}</span>
          </TabButton>
        )}
        <TabButton $active={activeTab === 'conferentes'} onClick={() => { setActiveTab('conferentes'); setSearchQuery(''); }}>
          Conferentes
          <span className="count">{filteredUsers.filter(u => u.role === 'conferente').length}</span>
        </TabButton>
        <TabButton $active={activeTab === 'gestores'} onClick={() => { setActiveTab('gestores'); setSearchQuery(''); }}>
          Gestores
          <span className="count">{filteredUsers.filter(u => u.role === 'gestor').length}</span>
        </TabButton>
        <TabButton $active={activeTab === 'visualizadores'} onClick={() => { setActiveTab('visualizadores'); setSearchQuery(''); }}>
          Visualizadores
          <span className="count">{filteredUsers.filter(u => u.role === 'visualiador' || u.role === 'master' || u.role === 'visualizador').length}</span>
        </TabButton>
        <TabButton $active={activeTab === 'distribuidores'} onClick={() => { setActiveTab('distribuidores'); setSearchQuery(''); }}>
          Distribuidores
          <span className="count">{filteredDist.length}</span>
        </TabButton>
      </TabContainer>

      <CardList>
        {loading ? (
          <Skeleton variant='cards' cardsCount={6} />
        ) : (
          <>
            {activeTab === 'suporte' && renderUserList(filteredUsers.filter(u => u.role === 'suporte'))}
            {isSuperAdmin && activeTab === 'administradores' && renderUserList(filteredUsers.filter(u => u.role === 'administrador'))}
            {activeTab === 'conferentes' && renderUserList(filteredUsers.filter(u => u.role === 'conferente'))}
            {activeTab === 'gestores' && renderUserList(filteredUsers.filter(u => u.role === 'gestor'))}
            {activeTab === 'visualizadores' && renderUserList(filteredUsers.filter(u => u.role === 'visualiador' || u.role === 'master' || u.role === 'visualizador'))}

            {activeTab === 'distribuidores' && (
              filteredDist.length === 0 ? (
                <EmptyState>
                  <FiSearch />
                  <p>Nenhum distribuidor encontrado</p>
                </EmptyState>
              ) : (
                filteredDist.map((distItem) => {
                  const isActive = distItem.status === '1' || distItem.status === 1
                  return (
                    <ModernCard key={distItem.id}>
                      <CardMainInfo>
                        <AvatarCircle $gradientType="dist">
                          {getInitials(distItem.fantasy_name || distItem.name)}
                        </AvatarCircle>
                        <InfoDetails>
                          <div className="name-wrapper">
                            <h3>{distItem.fantasy_name || distItem.name}</h3>
                            <BadgeRole $type="dist">Distribuidor</BadgeRole>
                            {distItem.cod_dist && (
                              <span style={{ fontSize: 12, background: 'rgba(255,255,255,0.05)', padding: '2px 8px', borderRadius: 6, color: '#94a3b8', fontFamily: 'Montserrat', fontWeight: 600 }}>
                                Cód: {distItem.cod_dist}
                              </span>
                            )}
                          </div>
                          <div className="meta-wrapper">
                            <span className="item" title="Razão Social">
                              Razão: {distItem.name}
                            </span>
                            {distItem.cnpj && (
                              <span className="item" title="CNPJ">
                                CNPJ: {distItem.cnpj}
                              </span>
                            )}
                            {distItem.response_telefone && (
                              <span className="item" title="Telefone">
                                <FiPhone />
                                {distItem.response_telefone}
                              </span>
                            )}
                            {distItem.response_email && (
                              <span className="item" title="E-mail">
                                <FiMail />
                                {distItem.response_email}
                              </span>
                            )}
                            <span className="item" title="Data da última alteração">
                              <FiClock />
                              {new Date(
                                new Date(distItem.created_at).getTime() + 3 * 60 * 60 * 1000,
                              ).toLocaleDateString('pt-BR')}
                            </span>
                          </div>
                        </InfoDetails>
                      </CardMainInfo>

                      <CardActions>
                        <StatusTag
                          $isActive={isActive}
                          onClick={() => (isActive ? toggleStatusDist(distItem) : toggleStatusActiveDist(distItem))}
                          title={isActive ? 'Inativar distribuidor' : 'Ativar distribuidor'}
                        >
                          {isActive ? 'Ativo' : 'Inativo'}
                        </StatusTag>

                        <IconButton
                          className="edit"
                          onClick={() => {
                            setSelectedDist(distItem)
                            setOpenModalDist(true)
                          }}
                          title="Editar"
                        >
                          <FiEdit2 />
                        </IconButton>
                      </CardActions>
                    </ModernCard>
                  )
                })
              )
            )}
          </>
        )}
      </CardList>

      <UserCreate
        isOpen={openCreateModal}
        setCloseModal={() => setOpenCreateModal(false)}
        onSuccess={() => {
          fetchUsers()
          fetchDist()
        }}
      />

      {openModal && (
        <ModalUserEdit
          key={selectedUser?.id}
          name={name}
          setName={setName}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          nickname={nickname}
          phone={phone}
          setPhone={setPhone}
          status={status}
          setStatus={setStatus}
          loading={loading}
          handlePhoneChange={handlePhoneChange}
          handleClick={handleEditClick}
          setCloseModal={() => {
            setOpenModal(false)
            setSelectedUser(null)
          }}
          role={selectedUser?.role}
          vincMarca={vincMarca}
          setVincMarca={setVincMarca}
          vincDist={vincDist}
          setVincDist={setVincDist}
          distGestor={distGestor}
          setDistGestor={setDistGestor}
          distsVisualizador={distsVisualizador}
          setDistsVisualizador={setDistsVisualizador}
        />
      )}

      {openModalDist && selectedDist && (
        <ModalDistEdit
          data={selectedDist}
          setData={setSelectedDist}
          users={users}
          loading={loading}
          handleClick={handleEditDistClick}
          setCloseModal={() => {
            setOpenModalDist(false)
            setSelectedDist(null)
          }}
          handlePhoneChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const formatted = formatPhone(e.target.value)
            setSelectedDist({ ...selectedDist, response_telefone: formatted })
          }}
        />
      )}
    </Content>
  )
}

export default UserList
